// @flow
import ErrorBoundary from './ErrorBoundary'
import { withRouter } from 'react-router'
import { compose } from 'redux'

export default compose(
  withRouter
)(ErrorBoundary)
